import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A smart (funny?) words I said",
  "description": "",
  "published": "2009-10-21T00:00:00.000Z",
  "redirect_from": ["/blog/a-smart-funny-words-i-said/swizec/780"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Electronics weren't meant to withstand the full force of a woman's love.`}</p>
    </blockquote>
    <p>{`(when arguing with a mate who broke her camera)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      